import { Component } from '@angular/core';

@Component({
  selector: 'app-empty',
  template: `
    <div class="tw-flex-center flex-column">
      <i
        class="fas fa-exclamation-circle tw-absolute text-gray tw-fs-[5rem]"
      ></i>
      <h3 class="tw-text-center text-gray">{{ 'common.empty' | translate }}</h3>
    </div>
  `,
  styles: ['h3 { margin-top: 110px; }'],
  standalone: false,
})
export class EmptyComponent {
  constructor() {}
}
